import * as React from 'react'
import I18n from '../../../../core/i18n'
import { IJsonResponse } from '../../../../core/JsonApiSerializer'
import { adminService } from '../../../../core/services'
import { InputText, InputFile } from '../../../atoms'
import AdminLayoutEdit from '../_layouts/edit'
import * as interfaces from '../../../../static/interfaces'

declare var window: interfaces.IWindow

interface IProps {
  area: IJsonResponse
}

const FIELDS = {
  id: 'id',
  name: 'name',
  name_ja: 'name_ja',
  position: 'position',
}

const title = I18n.t('admin.edit', {
  model: I18n.t('area', { scope: 'activerecord.models' }),
})

const AdminAreaEdit: React.FC<IProps> = props => {
  const { data: area } = adminService.getDataFromJson(props.area)
  const [image, setImage] = React.useState(null)
  const handleSubmit = React.useCallback(
    async (initialValues, values) => {
      const formData = new FormData()
      Object.keys(values).forEach(key => {
        formData.append(`area[${key}]`, values[key])
      })
      if (image) {
        formData.append('area[image]', image)
      }
      const { updatedArea, flush } = await adminService.updateArea(area.id, formData)
      window.flashMessages.addMessage({ text: flush.message, type: flush.type })
      location.href = '/admin/areas'
    },
    [image]
  )

  return (
    <AdminLayoutEdit
      model="area"
      title={title}
      fields={FIELDS}
      indexLink="/admin/areas"
      formItems={
        <>
          <InputText
            readonly={true}
            name="id"
            defaultValue={area.id}
            label={I18n.t('generic.id')}
          />
          <InputText
            required={true}
            name="name"
            defaultValue={area.name}
            label={I18n.t('generic.name')}
          />
          <InputText
            required={false}
            name="name_ja"
            defaultValue={area.name_ja}
            label={I18n.t('generic.name_ja')}
          />
          <InputText
            required={true}
            name="position"
            defaultValue={area.position}
            label={I18n.t('generic.position')}
          />
          <InputFile
            name="image"
            defaultValue={area.image_url || null}
            onChangeHandler={event => {
              setImage(event.currentTarget.files[0])
            }}
            label={I18n.t('generic.image')}
          />
        </>
      }
      handleSubmit={handleSubmit}
    />
  )
}

export default AdminAreaEdit
